import { lazy } from "react";

const MaterialIndustryList = lazy(() => import("./MaterialIndustryList"));
const MaterialGroup = lazy(() => import("./MaterialGroup"));
const MaterialType = lazy(() => import("./MaterialType"));
const MaterialSuggest = lazy(() => import("./MaterialSuggest"));
const CreateMaterialSuggest = lazy(() => import("./CreateMaterialSuggest"));
const UpdateMaterialSuggest = lazy(() => import("./UpdateMaterialSuggest"));
const Material = lazy(() => import("./Material"));
const MaterialUpdate = lazy(() => import("./MaterialUpdate"));
const RawMaterialsList = lazy(() => import("./MaterialRaw"));
const RawMaterialForm = lazy(() => import("./RawMaterialForm"));
const BaoCaoDieuChinhGia = lazy(() => import("./BaoCaoDieuChinhGia"));
const SemiFinishedProductForm = lazy(() => import("./SemiFinishedProductForm"));
const SemiFinishedProductsList = lazy(() =>
  import("./SemiFinishedProductsList")
);
const PurchaseSemiFinishedProductForm = lazy(() =>
  import("./PurchaseSemiFinishedProductForm")
);
const PurchaseSemiFinishedProductsList = lazy(() =>
  import("./PurchaseSemiFinishedProductsList")
);

export {
  BaoCaoDieuChinhGia,
  CreateMaterialSuggest,
  Material,
  MaterialGroup,
  MaterialIndustryList,
  MaterialSuggest,
  MaterialType,
  MaterialUpdate,
  PurchaseSemiFinishedProductForm,
  PurchaseSemiFinishedProductsList,
  RawMaterialForm,
  RawMaterialsList,
  SemiFinishedProductForm,
  SemiFinishedProductsList,
  UpdateMaterialSuggest,
};
